import React, { useEffect, useRef, useState } from "react"
import {
  MapContainer,
  TileLayer,
  GeoJSON,
} from "react-leaflet"
import "leaflet/dist/leaflet.css"
import FitBoundsToData from "./utils/leaflet/FitBoundsToData"
import LegendControl from "./utils/leaflet/IndecatorLegend";
import L from "leaflet"
import {
  fetchDistrictBoundary,
  fetchIndicatorsData,
} from "../../Utils/IndicatorsUtils";
import useApi from "../../Hooks/useApi";
import { isAuthenticated } from "../../Helpers/authHelper";
import { useTranslation } from "react-i18next";



const IndicatorMap = ({ indicators, year }) => {
  const [districtData, setDistrictData] = useState(null);
  const [cityData, setCityData] = useState(null);
  const [cityLoading, setCityLoading] = useState(false);
  const { request } = useApi({ isPublic: !isAuthenticated() });
  const { t } = useTranslation();

  useEffect(() => {
    fetchDistrictBoundary(request)
      .then(setDistrictData)
      .catch((error) => console.error("Failed to fetch district boundary:", error));
  }, [])

  useEffect(() => {
    setCityData(null);
    setCityLoading(true);
    fetchIndicatorsData(request, indicators, year)
      .then(setCityData)
      .catch((error) => console.error("Failed to fetch indicators data:", error))
      .finally(() => setCityLoading(false));
  }, [indicators, year])



  // Style for districts
  const getDistrictStyle = (feature) => {
    const grayDistricts = ["Khulna", "Dhaka", "Chittagong"]
    const isGray = grayDistricts.includes(feature.properties.district)

    return {
      fillColor: isGray ? "#808080" : "#FFFF00",
      weight: 1,
      opacity: 1,
      color: "#000000",
      fillOpacity: 1,
      dashArray: "1 2",
    }
  }

  const cityPointToLayer = (feature, latlng) => {
    const renderValue = feature.properties.renderdata || 0
    const zoom = mapRef.current?.getZoom?.() || 7

    // Use a base size and scale it down on low zoom, up on high zoom
    const baseRadius = Math.sqrt(renderValue) * 1.5 // sqrt to avoid huge values
    const scaleFactor = zoom / 7// adjust this to control growth/shrink speed
    const radius = Math.max(3, baseRadius * scaleFactor)

    const fillColor = getColorByValue(renderValue)

    return L.circleMarker(latlng, {
      radius,
      fillColor,
      color: fillColor,  // border color
      weight: 1,
      opacity: 1,
      fillOpacity: 1,
    })
  }

  const getColorByValue = (data) => {
    let maxValue = 99;
    if (!data) {
      return '#eeeeee';
    }
    let lowValue_color = [0, 255, 0];
    let highValue_color = [255, 0, 0];
    let w1 = data / maxValue;
    let w2 = 1 - w1;
    let rgb = [Math.round(lowValue_color[0] * w1 + highValue_color[0] * w2),
    Math.round(lowValue_color[1] * w1 + highValue_color[1] * w2),
    Math.round(lowValue_color[2] * w1 + highValue_color[2] * w2)
    ];
    return 'rgb(' + rgb[0] + ', ' + rgb[1] + ', ' + rgb[2] + '0)';
  }


  const [zoomKey, setZoomKey] = useState(0)

  useEffect(() => {
    const map = mapRef.current
    if (!map) return

    const handleZoom = () => setZoomKey((prev) => prev + 1)

    map.on("zoomend", handleZoom)
    return () => map.off("zoomend", handleZoom)
  }, [])
  const mapRef = useRef(null)

  return (
    <div style={{ height: "73vh", width: "100%", position: "relative" }}>
      {!cityLoading && (!cityData || cityData.features?.length === 0) && (
        <div className="absolute top-1/2 left-1/2 z-[1000] -translate-x-1/2 -translate-y-1/2 bg-white/90 px-6 py-4 rounded-lg shadow-lg text-center pointer-events-none">
          <p className="m-0 font-bold text-sm text-gray-600">
            {t(`indicators.no_data_found`)}
          </p>
        </div>
      )}
      <MapContainer
        center={[23.777176, 90.399452]}

        zoom={4}
        zoomControl={false}
        style={{ height: "100%", width: "100%" }}
        whenCreated={(mapInstance) => (mapRef.current = mapInstance)}
      >
        <TileLayer
          url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />

        {districtData && (
          <>
            <GeoJSON data={districtData} style={getDistrictStyle} />
            <FitBoundsToData data={districtData} />
            <LegendControl />
          </>
        )}

        {districtData && cityData && cityData.features?.length > 0 && (
          <GeoJSON
            key={`city-layer-${zoomKey}-${JSON.stringify(indicators)}`}
            data={cityData}
            pointToLayer={cityPointToLayer}
            onEachFeature={(feature, layer) => {
              layer.bindPopup(`<b>${feature.properties.name}</b>${indicators ? `<br/>Value: ${feature.properties.renderdata || 0} %` : ''}`);
            }}
          />



        )}

      </MapContainer>
    </div>
  )
}

export default IndicatorMap
